module.exports = __webpack_public_path__ + "img/16.04de24ee.jpg";